import config from '../config'
import http from '../http'
import {
  getAnalysisData as mockGetAnalysisData,
  getBalanceData as mockGetBalanceData,
  getBalanceRules as mockGetBalanceRules,
  saveBalanceRules as mockSaveBalanceRules
} from '@/mock/energyFlow'

export function getAnalysisData(params) {
  if (config.useMock) {
    return mockGetAnalysisData(params)
  }
  return http.get(`${config.api}/energy/flow/analysis`, { params }).then(res => res.data)
}

export function getBalanceData(params) {
  if (config.useMock) {
    return mockGetBalanceData(params)
  }
  return http.get(`${config.api}/energy/flow/balance`, { params }).then(res => res.data)
}

export function getBalanceRules() {
  if (config.useMock) {
    return mockGetBalanceRules()
  }
  return http.get(`${config.api}/energy/flow/balance/rules`).then(res => res.data)
}

export function saveBalanceRules(data) {
  if (config.useMock) {
    return mockSaveBalanceRules(data)
  }
  return http.put(`${config.api}/energy/flow/balance/rules`, data).then(res => res.data)
}
